<div class="modal-header">
    <h5 class="modal-title" id="new-composition">{{ title | translate}}</h5>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <!-- Cards prompt gallery -->
    <div class="content-wrapper container-xxl p-0" *ngIf="prompts">
        <div class="row match-height">
            <div class="col-sm-12 col-md-6 col-xl-4" *ngFor="let item of prompts">
                <div class="card" (click)="selectPrompt(item)">
                    <div class="card-body">
                        <p class="card-text">{{item}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Citations -->
    <pre class="text-dark bg-white" *ngIf="content">{{content}}</pre>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">{{'COMMON.BUTTONS.CLOSE' | translate}}</button>
</div>
